import { NgModule } from '@angular/core';

import { TimerComponent } from './timer.component';
import { TimerService } from "./timer.service";

@NgModule({
    imports: [],
    exports: [TimerComponent],
    declarations: [TimerComponent],
    providers: [TimerService],
})
export class TimerModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/timer/timer.module.ts